import { ApiError } from '../api/client';
import { apiErrorMessage } from '../api/errorMessage';

/// Translate an error from `confirmPasswordReset` into user-facing copy.
/// The server collapses NotFound / Expired / AlreadyUsed into a single
/// 400; reword its generic copy into something a user can actually act
/// on. Everything else routes through the shared formatter.
export function formatResetConfirmError(err: unknown): string {
  if (
    err instanceof ApiError
    && err.status === 400
    && /no longer valid/i.test(err.message)
  ) {
    return 'This reset link is no longer valid. Request a new one to try again.';
  }
  return apiErrorMessage(err);
}
